import { Skeleton } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import React, { useEffect, useState } from 'react';

import StoreCard from './StoreCard';
import { ShouldRender } from '../shared/basic/ShouldRender';
import { formateErrorObject } from '../shared/formateErrorObject';
import { notify } from '../shared/notify';
import HomepageSlider from '../V2/HomePage/HomepageSlider';
import { getAllStore } from '../../services/Store';
import { PaginationProps } from '../../utils/interfaces/Orders';
import { IStore } from '../../utils/interfaces/Store';

interface Props {
  categoryId?: string | null;
  categoryName?: string;
  name?: string;
  authorId?: string;
}

const PaginatedStoreSlider: React.FC<Props> = ({
  categoryName,
  name,
  authorId,
}) => {
  const [storeCardDataPagination, setStoreDataPagination] = useState<IStore[]>(
    [],
  );
  const [page, setPage] = useState<number>(1);
  const [loading, setLoading] = useState(false);
  const [isPaginateShift, setIsPaginateShift] = useState(true);

  const [paginationData, setPaginationData] = useState<PaginationProps>();
  const screens = useBreakpoint();

  const handleFetchStoreData = async () => {
    try {
      setLoading(true);

      const response = await getAllStore({
        page: page,
        ...(authorId && { authorId }),
      });
      const data = response?.data?.data || [];

      if (page === 1) {
        setStoreDataPagination(data);
      } else {
        setStoreDataPagination((prevData) => [...prevData, ...data]);
      }

      setPaginationData({
        total: response?.data?.metadata?.total || 0,
      });
    } catch (error: any) {
      const message = formateErrorObject(error);
      notify(message, 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleFetchStoreData();
  }, [page, authorId]);

  const handlePagination = () => {
    if (
      paginationData &&
      storeCardDataPagination.length < paginationData?.total
    )
      setPage((prevPage) => prevPage + 1);
  };

  return (
    <>
      <ShouldRender check={storeCardDataPagination.length > 0 || loading}>
        <HomepageSlider
          heading={name ?? (categoryName as string) ?? 'Store'}
          setIsPaginateShift={setIsPaginateShift}
          isPaginateShift={isPaginateShift}
          onPagination={handlePagination}
          loading={!!storeCardDataPagination}
          total={paginationData?.total || 0}
          imageWidths={[120, 200, 320]}
        >
          <StoreCard stores={storeCardDataPagination} />
          <ShouldRender check={loading || isPaginateShift}>
            {Array.from({ length: 5 }).map((_, index) => (
              <span
                key={index}
                className='group cursor-pointer p-1 md:p-1.5 bg-transparent no-select flex flex-col'
              >
                <Skeleton.Button
                  style={{
                    width: screens.xl
                      ? '316px'
                      : screens.lg
                        ? '316px'
                        : '200px',
                    height: '100%',
                  }}
                  active={true}
                  className='rounded-lg min-h-[300px]'
                />
              </span>
            ))}
          </ShouldRender>
        </HomepageSlider>
      </ShouldRender>
    </>
  );
};

export default PaginatedStoreSlider;
